// import Course from '@/page/Course.vue'
const SchoolPaper = resolve =>require(['@/page/SchoolPaper.vue'], resolve)

export default {
	path: '/home/schoolPaper',
	component: SchoolPaper,
	meta:{
		title: '试卷库',
		path:'/home/schoolPaper',
    breadList: [
      {
        title: '题库',
        path: '/homePage'
      },
      {
        title: '试卷列表',
        path:'/home/schoolBank'
      }]
	}
}



// WEBPACK FOOTER //
// ./src/router/schoolPaper.js